import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OktaWrapperService } from './okta-wrapper.service';
import { UserService } from '@myapp/modules/fwcore/services';

@Injectable({
  providedIn: 'root'
})
export class LoginTrackerService {

  constructor(
    private oktaWrapper: OktaWrapperService,
    private userService: UserService
  ) {
    // Initialize with config - you may need to inject CONFIG_SETTINGS here too
    // For now using placeholder values
    
    // Subscribe to authentication changes to track login
    this.oktaWrapper.authenticationChanged.subscribe((isAuth: boolean) => {
      if (isAuth) {
        this.updateLastLoginTime().subscribe({
          next: (response) => {
            console.log('Last login time updated successfully', response);
          },
          error: (error) => {
            console.error('Failed to update last login time', error);
          }
        });
      }
    });
  }

  public updateLastLoginTime(): Observable<any> {
    // Call the existing UserService method
    return this.userService.updateLastLoginTime();
  }


}